const PREFIX = 'EVENT'

export const EVENT_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`
export const EVENT_LOADING_CATEGORIES_STATUS = `${PREFIX}_LOADING_CATEGORIES_STATUS`
export const EVENT_GET = `${PREFIX}_GET`
export const EVENTS_FETCH_CATEGORIES = `${PREFIX}_GET_CATEGORIES`
export const EVENTS_CLEAR = `${PREFIX}_CLEAR`
export const EVENTS_FETCH_CATEGORIES_ERROR = `${PREFIX}_GET_CATEGORIES_ERRORS`
export const EVENT_GET_ERROR = `${PREFIX}_GET_ERRORS`
export const EVENTS_FETCH = `${PREFIX}_FETCH`
export const EVENTS_FETCH_ERROR = `${PREFIX}_FETCH_ERRORS`
export const AGENDA_EVENT_GET = `AGENDA_${PREFIX}_GET`
export const EVENT_AGENDA_UPDATE_ITEM = `${PREFIX}_AGENDA_UPDATE_ITEM`
export const ATTENDEES_EVENT_GET = `ATTENDEES_${PREFIX}_GET`
export const ATTENDEE_EVENT_GET = `ATTENDEE_${PREFIX}_GET`
export const ATTENDEES_EVENT_CLEAR = `ATTENDREES_${PREFIX}_CLEAR`
export const REMOVE_ATTENDEES_EVENT = `ATTENDEES_${PREFIX}_REMOVE`
export const PARTNERS_EVENT_GET = `PARTNERS_${PREFIX}_GET`
export const SESSION_EVENT_GET = `SESSION_${PREFIX}_GET`
export const SESSION_EVENT_CLEAR = `SESSIONS_${PREFIX}_CLEAR`
export const SESSION_EVENT_QUESTIONS_GET = `SESSION_${PREFIX}_QUESTIONS_GET`
export const SESSION_EVENT_QUESTIONS_CLEAR = `SESSION_${PREFIX}_QUESTIONS_CLEAR`
export const SESSION_EVENT_QUESTION_UPDATE = `SESSION_${PREFIX}_QUESTION_UPDATE`
export const EVENT_GET_TRACKS = `${PREFIX}_GET_TRACKS`
export const EVENT_TRACKS_LOADING_STATUS = `${PREFIX}_TRACKS_LOADING_STATUS`
export const EVENT_CLEAR_TRACKS = `${PREFIX}_CLEAR_TRACKS`

export const GET_ACTION_FILES = `${PREFIX}_GET_ACTION_FILES`
export const GET_ACTION_LINKS = `${PREFIX}_GET_ACTION_LINKS`

export const EVENT_MY_AGENDA_LOADING_STATUS = `${PREFIX}_MY_AGENDA_LOADING_STATUS`
export const EVENT_POLLS_LOADING_STATUS = `${PREFIX}_POLLS_LOADING_STATUS`
export const UPDATE_EVENT_POLLS = `UPDATE_${PREFIX}_POLLS`
export const EVENT_SPEAKERS_GET = `${PREFIX}_SPEAKER_GET`
export const EVENT_SPEAKERS_CLEAR = `${PREFIX}_SPEAKERS_CLEAR`

export const EVENT_RATINGS_LOADING_STATUS = `${PREFIX}_RATINGS_LOADING_STATUS`
export const UPDATE_EVENT_RATINGS = `UPDATE_${PREFIX}_RATINGS`
export const UPDATE_SESSION_RATINGS = `UPDATE_${PREFIX}_SESSION_RATINGS`

export const EVENT_GET_EXHIBITOR = `${PREFIX}_GET_EXHIBITOR`
export const SET_FOLLOW_STATUS = `${PREFIX}_SET_FOLLOW_STATUS`
export const SET_FOLLOW_NOTE = `${PREFIX}_SET_FOLLOW_NOTE`
export const DELETE_FOLLOW_NOTE = `${PREFIX}_DELETE_FOLLOW_NOTE`

export const GET_BOOT_STAFF_LIST = `${PREFIX}_GET_BOOT_STAFF_LIST`
export const BOOT_STAFF_LOADING_STATUS = `${PREFIX}_BOOT_STAFF_LOADING_STATUS`
